import cn from 'classnames'
import { observer } from 'mobx-react'
import React from 'react'
import { PlacesType, Tooltip } from 'react-tooltip'

import * as Styles from './styles'

interface MapsTooltipProps {
   className?: string
   content: string
   tooltipId: string
   place?: PlacesType
}

const MapsTooltip = (props: MapsTooltipProps): React.ReactElement => {
   const { className, content, tooltipId } = props

   return (
      <Tooltip
         id={tooltipId}
         place={props.place ?? 'top'}
         content={content}
         className={cn(Styles.tooltipStyles, className)}
      />
   )
}

export default observer(MapsTooltip)
